import { Columns2, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { ProductComparisonSnapshot } from "../model";
import { useComparisonStore } from "../store/comparison-store";

/**
 * Karşılaştırma turunun sohbette çizdiği tek şey: sonuç ekranını açan buton.
 */
export const ComparisonButton: React.FC<{
  comparison: ProductComparisonSnapshot;
}> = ({ comparison }) => {
  const { t } = useTranslation();
  const openComparison = useComparisonStore((state) => state.openComparison);

  return (
    <div className="flex justify-start">
      <button
        type="button"
        onClick={() => openComparison(comparison.productIds)}
        className="flex w-fit max-w-full items-center gap-3 rounded-2xl border border-border-secondary bg-bg-primary px-3 py-2.5 text-start shadow-sm transition-colors hover:bg-bg-secondary dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700"
      >
        <span className="flex size-9 shrink-0 items-center justify-center rounded-xl bg-module-accent-soft text-module-accent">
          <Columns2 className="size-4" />
        </span>
        <span className="min-w-0">
          <span className="block truncate text-sm font-semibold text-text-primary dark:text-gray-100">
            {t("comparison.open")}
          </span>
          <span className="block truncate text-xs text-text-tertiary dark:text-gray-400">
            {t("comparison.count", { count: comparison.productIds.length })}
          </span>
        </span>
        <ChevronRight className="size-4 shrink-0 text-text-tertiary rtl:rotate-180 dark:text-gray-400" />
      </button>
    </div>
  );
};
